import React from 'react';
import { useSelector } from 'react-redux';
import { makeSelectDocumentValue } from 'services/documents/selectors';
import { DocumentId } from 'services/documents/types';
import { AppState } from 'services/types';
// @ts-ignore
import FormattedDate from 'components/FormattedDate';

interface Props {
    documentId: DocumentId;
}

function DocumentCreatedAt({ documentId }: Props): React.ReactElement {
    const createdAt = useSelector((state: AppState) =>
        makeSelectDocumentValue('createdAt')(state, { documentId })
    );

    return <FormattedDate value={createdAt} format="MMM D" />;
}

export default DocumentCreatedAt;
